import { render, staticRenderFns } from "./NewAvailabilityHoursSelect.vue?vue&type=template&id=a2927f84&scoped=true"
import script from "./NewAvailabilityHoursSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewAvailabilityHoursSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewAvailabilityHoursSelect.vue?vue&type=style&index=0&id=a2927f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2927f84",
  null
  
)

export default component.exports